// ---- Artikelnummer-Anzeige: Lieferanten-Praefixe abstreifen ----
// Interne SKUs tragen teils ein Lieferanten-Praefix (TD-, WAVE-, kuenftig
// IM-) — Geschaeftsgeheimnis, darf nie beim Kunden erscheinen. Diese
// Funktion uebersetzt eine SKU in die Anzeige-Artikelnummer; die SKU
// selbst bleibt ueberall unveraendert. Gleiche Logik serverseitig in
// snippets/artikelnummer.liquid — neue Praefixe IMMER an beiden Stellen
// ergaenzen. Spaeter gewinnt die eigene NEXUS-Artikelnummer (Metafeld
// custom.artikelnummer), dieser Filter bleibt als doppelter Boden.
window.nexusArtikelAnzeige = function (sku) {
  var s = String(sku == null ? '' : sku).trim();
  var praefixe = ['TD-SYNNEX-', 'TD-SYNNEX_', 'TD-SYNNEX', 'TDSYNNEX-', 'TDSYNNEX_', 'TDSYNNEX', 'TD-', 'WAVE-', 'INGRAM-', 'INGRAM_', 'INGRAM', 'IM-'];
  for (var i = 0; i < praefixe.length; i++) {
    if (s.indexOf(praefixe[i]) === 0) return s.slice(praefixe[i].length);
  }
  return s;
};

// ---- 3D tilt effect for product cards ----
  (function initTilt() {
    // War: '.product-card, .deal-card'. Die Angebots-Karte ist bewusst
    // ausgenommen — sie hat mit der Neugestaltung eigene Effekte
    // (Lauflicht, Spotlight, schwebendes Produkt), und die zusätzliche
    // Neigung zum Mauszeiger wirkte daneben unruhig.
    var tiltEls = document.querySelectorAll('.product-card');
    var maxTilt = 8; // degrees
    var lerpFactor = 0.35; // smoothing amount per animation frame

    tiltEls.forEach(function (el) {
      var targetRotateX = 0;
      var targetRotateY = 0;
      var currentRotateX = 0;
      var currentRotateY = 0;
      var targetLift = 0;
      var currentLift = 0;
      var rafId = null;

      function animate() {
        currentRotateX += (targetRotateX - currentRotateX) * lerpFactor;
        currentRotateY += (targetRotateY - currentRotateY) * lerpFactor;
        currentLift += (targetLift - currentLift) * lerpFactor;

        el.style.transform = 'perspective(900px) rotateX(' + currentRotateX.toFixed(2) + 'deg) rotateY(' + currentRotateY.toFixed(2) + 'deg) translateY(' + currentLift.toFixed(2) + 'px)';

        // Keep animating while there's meaningful movement left, otherwise stop the loop
        var settled = Math.abs(targetRotateX - currentRotateX) < 0.01 &&
                      Math.abs(targetRotateY - currentRotateY) < 0.01 &&
                      Math.abs(targetLift - currentLift) < 0.01;

        if (!settled) {
          rafId = requestAnimationFrame(animate);
        } else {
          rafId = null;
        }
      }

      function ensureAnimating() {
        if (rafId === null) {
          rafId = requestAnimationFrame(animate);
        }
      }

      el.addEventListener('mousemove', function (e) {
        var rect = el.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;
        targetRotateY = ((x - centerX) / centerX) * maxTilt;
        targetRotateX = -((y - centerY) / centerY) * maxTilt;
        targetLift = -4;
        ensureAnimating();
      });

      el.addEventListener('mouseleave', function () {
        targetRotateX = 0;
        targetRotateY = 0;
        targetLift = 0;
        ensureAnimating();
      });
    });
  })();

// ---- Scroll reveal for sections (subtle fade + rise) ----
  (function initReveal() {
    var targets = document.querySelectorAll('.cat-card, .product-card, .deal-neu, .trust-inner, .newsletter-card');
    targets.forEach(function (el) { el.classList.add('reveal'); });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    targets.forEach(function (el) { observer.observe(el); });
  })();

// ---- NEXUS-Bestätigungsdialog ----
// Ersetzt das nackte window.confirm() (grauer Browser-Kasten, der je nach
// Browser/System völlig anders aussieht) durch ein Modal im Theme-Design.
// Promise-basiert, weil ein eigenes Modal — anders als confirm() — den
// Code nicht anhalten kann: Aufrufer machen im .then(ok => ...) weiter.
// Global (window.*), damit auch Seiten-Skripte wie warenkorb.js ihn nutzen.
  window.nexusBestaetigen = function (optionen) {
    optionen = optionen || {};
    return new Promise(function (resolve) {
      var overlay = document.createElement('div');
      overlay.className = 'nx-dialog-overlay';

      var dialog = document.createElement('div');
      dialog.className = 'nx-dialog';
      dialog.setAttribute('role', 'alertdialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-labelledby', 'nxDialogTitel');

      var icon = document.createElement('div');
      icon.className = 'nx-dialog-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>';

      var titel = document.createElement('h3');
      titel.className = 'nx-dialog-titel';
      titel.id = 'nxDialogTitel';
      titel.textContent = optionen.titel || 'Bist du sicher?';

      var text = document.createElement('p');
      text.className = 'nx-dialog-text';
      text.textContent = optionen.text || '';

      var aktionen = document.createElement('div');
      aktionen.className = 'nx-dialog-aktionen';

      var abbrechenBtn = document.createElement('button');
      abbrechenBtn.type = 'button';
      abbrechenBtn.className = 'nx-dialog-btn nx-dialog-btn-abbrechen';
      abbrechenBtn.textContent = optionen.abbrechenText || 'Abbrechen';

      var okBtn = document.createElement('button');
      okBtn.type = 'button';
      okBtn.className = 'nx-dialog-btn nx-dialog-btn-ok';
      okBtn.textContent = optionen.okText || 'Entfernen';

      aktionen.appendChild(abbrechenBtn);
      aktionen.appendChild(okBtn);
      dialog.appendChild(icon);
      dialog.appendChild(titel);
      dialog.appendChild(text);
      dialog.appendChild(aktionen);
      overlay.appendChild(dialog);
      document.body.appendChild(overlay);

      var vorherFokussiert = document.activeElement;

      function schliessen(ergebnis) {
        document.removeEventListener('keydown', tastenHandler, true);
        overlay.classList.remove('is-open');
        window.setTimeout(function () {
          if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        }, 220);
        if (vorherFokussiert && vorherFokussiert.focus) {
          try { vorherFokussiert.focus(); } catch (e) { /* Element evtl. weg */ }
        }
        resolve(ergebnis);
      }

      // capture-Phase, damit ESC nicht nebenbei auch das dahinterliegende
      // Warenkorb-Panel schließt, solange der Dialog offen ist.
      function tastenHandler(e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          e.stopPropagation();
          schliessen(false);
        } else if (e.key === 'Tab') {
          // Mini-Fokusfalle: Tab pendelt zwischen den beiden Knöpfen.
          e.preventDefault();
          if (document.activeElement === abbrechenBtn) okBtn.focus();
          else abbrechenBtn.focus();
        }
      }

      abbrechenBtn.addEventListener('click', function () { schliessen(false); });
      okBtn.addEventListener('click', function () { schliessen(true); });
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) schliessen(false);
      });
      document.addEventListener('keydown', tastenHandler, true);

      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        // Sichere Vorauswahl: Enter aus Versehen löscht nichts.
        abbrechenBtn.focus();
      });
    });
  };

// ---- Dialog-Wortlaut fürs Entfernen von Konfigurations-Positionen ----
// Zentral, damit Warenkorb-Seite (warenkorb.js) und Sidebar-Panel exakt
// dieselben Texte zeigen. Der Wortlaut richtet sich nach der Art der
// Position (_zusatz_art aus dem Konfigurator): Die Montage hat echte
// Folgen (Lieferzeit, Selbstbau), Zubehör wie Lizenz oder Riser-Kit macht
// das System nicht unvollständig — nur Kernbauteile tun das.
  window.nexusKonfigEntfernenDialog = function (zusatzArt) {
    if (zusatzArt === 'montage') {
      return {
        titel: 'Profi-Montage entfernen?',
        text: 'Damit entfallen Montage und Systemtest — deine Teile kommen dann einzeln verpackt zum Selbstbau (Versand in 2–3 Werktagen).',
        okText: 'Entfernen',
        abbrechenText: 'Montage behalten'
      };
    }
    if (zusatzArt === 'lizenz' || zusatzArt === 'riser_kit') {
      return {
        titel: 'Teil deiner PC-Konfiguration',
        text: 'Dieser Artikel gehört zu deiner Konfiguration. Wirklich entfernen?',
        okText: 'Entfernen',
        abbrechenText: 'Behalten'
      };
    }
    return {
      titel: 'Bauteil deiner PC-Konfiguration',
      text: 'Ohne dieses Bauteil ist dein System unvollständig. Wirklich entfernen?',
      okText: 'Entfernen',
      abbrechenText: 'Behalten'
    };
  };

// ---- Warenkorb-Anzeige aktualisieren (ohne Seitenwechsel) ----
// Bewusst AUSSERHALB von initCartPanel und vor dessen Abbruchbedingung
// (if (!trigger || !overlay) return): Der Konfigurator legt Artikel über
// /cart/add.js an und muss die Anzeige danach aktualisieren können — das
// darf nicht davon abhängen, ob die Warenkorb-Leiste vollständig im DOM
// ist. Vorher steckte diese Logik fest in der Mengen-Änderung und war von
// außen gar nicht erreichbar: Die Artikel landeten korrekt im Warenkorb,
// aber Zähler und Leiste erfuhren nichts davon — sichtbar wurde es erst
// nach einem Seitenwechsel, was wirkte, als passiere gar nichts.
  window.nexusWarenkorbAktualisieren = function (oeffnen) {
    // War: fetch der KOMPLETTEN aktuellen Seite, nur um daraus den
    // Panel-Ausschnitt zu übernehmen. Auf der Konfigurator-Seite ist das
    // ein sehr großes Dokument — der Grund für die spürbare Verzögerung.
    // /cart?view=panel liefert über templates/cart.panel.liquid
    // ausschließlich das Panel (ohne Kopf-/Fußzeile und Seiteninhalt).
    return fetch('/cart?view=panel', {
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var neuesDokument = parser.parseFromString(html, 'text/html');

        var neuesPanel = neuesDokument.getElementById('cartPanel');
        var aktuellesPanel = document.getElementById('cartPanel');
        if (neuesPanel && aktuellesPanel) {
          aktuellesPanel.innerHTML = neuesPanel.innerHTML;
          // Gleiche Vorsicht wie beim Mengen-Ändern: der Container wurde
          // durch den innerHTML-Austausch ersetzt, deshalb frisch abfragen.
          var neuerItemsContainer = document.getElementById('cartItems');
          if (neuerItemsContainer) {
            neuerItemsContainer.querySelectorAll('.qty-plus, .qty-minus, .cart-item-remove').forEach(function (btn) {
              btn.removeAttribute('href');
            });
          }
        }

        // Der Zähler steht im Header, nicht im Panel — die schlanke
        // Ansicht liefert die Artikelzahl deshalb als Datenattribut mit.
        var daten = neuesDokument.getElementById('cartPanelDaten');
        var aktuellerZaehler = document.getElementById('cartCountBadge');
        if (daten && aktuellerZaehler) {
          aktuellerZaehler.textContent = daten.getAttribute('data-item-count') || '0';
        }

        // Stößt die Neuberechnung von Zwischensumme, Artikelzahl,
        // Versandfortschritt und Lieferzeit an — die Logik dafür liegt in
        // initCartPanel und ist von hier aus nur über dieses Ereignis
        // erreichbar.
        document.dispatchEvent(new CustomEvent('nexus:warenkorb-aktualisiert'));

        if (oeffnen) {
          var overlayEl = document.getElementById('cartOverlay');
          var triggerEl = document.getElementById('cartTrigger');
          if (overlayEl) {
            overlayEl.classList.add('is-open');
            if (triggerEl) triggerEl.setAttribute('aria-expanded', 'true');
            document.body.style.overflow = 'hidden';
          }
        }
      })
      .catch(function () {
        // Netzwerkfehler oder Shopify antwortet nicht: Der Warenkorb selbst
        // ist davon nicht betroffen — der Artikel liegt bereits drin, nur
        // die Anzeige konnte nicht aktualisiert werden. Ohne diese
        // Behandlung brach die Funktion still ab und der Kunde sah keinerlei
        // Reaktion. Jetzt wird das Panel wenigstens geöffnet, damit er den
        // Warenkorb aufrufen kann.
        if (oeffnen) {
          var overlayEl = document.getElementById('cartOverlay');
          var triggerEl = document.getElementById('cartTrigger');
          if (overlayEl) {
            overlayEl.classList.add('is-open');
            if (triggerEl) triggerEl.setAttribute('aria-expanded', 'true');
            document.body.style.overflow = 'hidden';
          }
        }
      });
  };

// ---- Cart panel: slide-in with live subtotal, quantity, shipping progress ----
  (function initCartPanel() {
    var trigger = document.getElementById('cartTrigger');
    var overlay = document.getElementById('cartOverlay');
    var closeBtn = document.getElementById('cartCloseBtn');
    var itemsContainer = document.getElementById('cartItems');
    var emptyState = document.getElementById('cartEmptyState');
    var crosssell = document.getElementById('cartCrosssell');
    var footer = document.querySelector('.cart-footer');
    var subtotalEl = document.getElementById('cartSubtotal');
    var itemCountEl = document.getElementById('cartItemCount');
    var cartCountBadge = document.getElementById('cartCountBadge');
    var shippingText = document.getElementById('cartShippingText');
    var shippingFill = document.getElementById('cartShippingFill');
    var deliveryEstimate = document.getElementById('cartDeliveryEstimate');
    var deliveryText = document.getElementById('cartDeliveryText');
    if (!trigger || !overlay) return;

    var FREE_SHIPPING_THRESHOLD = 50;

    function formatEuro(value) {
      // Mit Tausenderpunkt, damit die JS-Anzeige zur serverseitigen
      // Liquid-Formatierung passt (4.599,00 € statt 4599,00 €).
      return value.toLocaleString('de-DE',
        { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function recalculate() {
      // War: die itemsContainer-Variable von der Initialisierung oben.
      // Nach einem Panel-Austausch (siehe nexusWarenkorbAktualisieren und
      // die Mengen-Änderung) zeigt die auf ein Element, das nicht mehr im
      // DOM hängt — querySelectorAll darauf liefert die ALTEN Artikel oder
      // gar nichts, ohne einen Fehler zu werfen. Folge: Artikelzahl,
      // Zwischensumme und der Fortschritt zum Gratisversand blieben auf
      // dem Stand von vor der Aktualisierung ("Warenkorb (2)" und "noch
      // 21,00 € bis zum kostenlosen Versand" bei über 4.000 € Warenwert).
      // Deshalb hier immer frisch abfragen.
      var aktuellerContainer = document.getElementById('cartItems') || itemsContainer;
      if (!aktuellerContainer) return;
      var items = aktuellerContainer.querySelectorAll('.cart-item');
      var subtotal = 0;
      var totalQty = 0;
      var maxDeliveryDays = 0;
      var maxDeliveryLabel = '';

      items.forEach(function (item) {
        var price = parseFloat(item.getAttribute('data-price')) || 0;
        var qty = parseInt(item.getAttribute('data-qty'), 10) || 1;
        subtotal += price * qty;
        totalQty += qty;

        // Each product can come from a different distributor, so the cart shows
        // the slowest (max) delivery estimate across all items — that's when the full order actually arrives.
        var days = parseInt(item.getAttribute('data-delivery-days'), 10) || 0;
        if (days > maxDeliveryDays) {
          maxDeliveryDays = days;
          maxDeliveryLabel = item.getAttribute('data-delivery-label') || '';
        }
      });

      if (subtotalEl) subtotalEl.textContent = formatEuro(subtotal);
      if (itemCountEl) itemCountEl.textContent = '(' + totalQty + ')';
      if (cartCountBadge) cartCountBadge.textContent = totalQty;

      // Update the combined delivery estimate for the whole cart
      if (deliveryEstimate && deliveryText) {
        if (items.length === 0) {
          deliveryEstimate.style.display = 'none';
        } else {
          deliveryEstimate.style.display = 'flex';
          deliveryText.textContent = 'Voraussichtliche Lieferung: ' + (maxDeliveryLabel || 'wird an der Kasse berechnet');
        }
      }

      // Update shipping progress
      if (shippingText && shippingFill) {
        if (subtotal >= FREE_SHIPPING_THRESHOLD) {
          shippingText.innerHTML = '<span class="cart-shipping-check"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg></span> Du hast <strong>kostenlosen Versand</strong> freigeschaltet!';
          shippingFill.style.width = '100%';
        } else {
          var remaining = FREE_SHIPPING_THRESHOLD - subtotal;
          var percent = Math.min(100, (subtotal / FREE_SHIPPING_THRESHOLD) * 100);
          shippingText.innerHTML = 'Noch <strong>' + formatEuro(remaining) + '</strong> bis zum kostenlosen Versand!';
          shippingFill.style.width = percent + '%';
        }
      }

      // Leerzustand: Der Hinweis "Dein Warenkorb ist noch leer" liegt als
      // .cart-empty INNERHALB von #cartItems (Liquid for/else) — der
      // Container darf bei leerem Korb also NICHT versteckt werden, sonst
      // verschwindet der Hinweis gleich mit und das Panel wirkt kaputt.
      // (#cartEmptyState/#cartCrosssell aus einem früheren Entwurf gibt es
      // im Markup nicht mehr.) Nur Fußzeile und Versand-Fortschritt haben
      // ohne Artikel nichts zu zeigen. Immer den AKTUELLEN Container
      // nehmen — nach einem Panel-Austausch wäre die alte Referenz tot.
      var isEmpty = items.length === 0;
      var container = document.getElementById('cartItems') || itemsContainer;
      if (container) container.style.display = 'block';
      var aktuellerFooter = document.querySelector('.cart-footer') || footer;
      if (aktuellerFooter) aktuellerFooter.style.display = isEmpty ? 'none' : 'block';
      var shippingProgress = document.querySelector('.cart-shipping-progress');
      if (shippingProgress) shippingProgress.style.display = isEmpty ? 'none' : 'block';
    }

    // War: reines optisches item.remove() im Browser, OHNE das echte
    // href des Links zu stoppen (kein preventDefault). Das bedeutete: bei
    // jedem Klick lief zusätzlich noch eine echte Navigation zu
    // /cart/change?line=X los. Bei mehreren SCHNELLEN Klicks
    // hintereinander (z.B. 4 Artikel schnell nacheinander löschen)
    // feuerten mehrere solcher Navigationen praktisch gleichzeitig, mit
    // `line`-Positionsnummern, die sich zwischen den Anfragen bereits
    // verschoben hatten (Position 1 gelöscht -> alte Position 2 rückt auf
    // Position 1 vor) — das erzeugte "Parameter line ist ungültig".
    //
    // Jetzt: echte AJAX-Anfragen über den line item KEY (data-key), der
    // pro Position stabil bleibt, egal was mit anderen Positionen
    // gleichzeitig passiert (Shopify erlaubt 'id' bei /cart/change.js als
    // entweder Varianten-ID ODER als "variant_id:key"-String, siehe
    // Shopify-Doku). Zusätzlich eine Warteschlange: mehrere Klicks
    // während eine Anfrage noch läuft werden nicht verworfen, sondern
    // nacheinander abgearbeitet — jede einzelne Löschung bekommt so
    // ihren eigenen synchronisierten Schritt, ohne dass sich line-
    // Nummern zwischen zwei gleichzeitig unterwegs befindlichen
    // Anfragen verschieben können.
    var cartPanelLadeAktiv = false;
    var cartPanelWarteschlange = [];

    function cartPanelNaechsteAusFuehren() {
      if (cartPanelLadeAktiv) return;
      var naechste = cartPanelWarteschlange.shift();
      if (!naechste) {
        overlay.classList.remove('is-aktualisiert-wird');
        return;
      }
      cartPanelLadeAktiv = true;
      overlay.classList.add('is-aktualisiert-wird');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: naechste.key, quantity: naechste.neueMenge })
      })
        .then(function (antwort) {
          if (!antwort.ok) throw new Error('Änderung fehlgeschlagen');
          // War: hier wurde die KOMPLETTE aktuelle Seite neu angefordert,
          // nur um den Panel-Ausschnitt daraus zu übernehmen — auf der
          // Konfigurator-Seite ein sehr großes Dokument und damit der
          // Grund für die spürbare Verzögerung beim Löschen. Jetzt läuft
          // es über dieselbe schlanke Funktion wie das Hinzufügen
          // (/cart?view=panel), die nur das Panel lädt. Dadurch gibt es
          // auch nur noch EINE Stelle, die den Austausch macht.
          return window.nexusWarenkorbAktualisieren();
        })
        .then(function () {
          cartPanelLadeAktiv = false;
          cartPanelNaechsteAusFuehren();
        })
        .catch(function () {
          // Bei einem Fehler die Seite neu laden statt den Kunden mit
          // einem nicht mehr synchronen Panel sitzen zu lassen.
          window.location.reload();
        });
    }

    // War: nur e.preventDefault() im Klick-Handler, um die href-Links zu
    // stoppen. Bei mehreren SCHNELLEN, programmatisch/nahezu gleichzeitig
    // ausgelösten Klicks (z.B. 4 Löschen-Klicks kurz hintereinander)
    // reichte das nicht zuverlässig aus — eine echte Browser-Navigation
    // zum alten href kam trotzdem durch, mit einer bereits veralteten
    // line-Nummer ("Parameter line ist ungültig"). Jetzt wird das href
    // selbst entfernt, sobald JS aktiv ist — dann gibt es für den
    // Browser gar kein Linkziel mehr, das er navigieren könnte, ganz
    // unabhängig vom Timing des Event-Handlers. Der href bleibt nur als
    // Fallback im ursprünglichen Liquid-Markup, falls JS mal nicht lädt.
    function cartPanelHrefsEntfernen() {
      itemsContainer.querySelectorAll('.qty-plus, .qty-minus, .cart-item-remove').forEach(function (btn) {
        btn.removeAttribute('href');
      });
    }
    cartPanelHrefsEntfernen();

    // Wichtig: Listener auf "overlay" (#cartOverlay), nicht auf
    // "itemsContainer" (#cartItems) — letzteres liegt INNERHALB von
    // #cartPanel und wird beim Update per innerHTML komplett ersetzt.
    // Ein Listener direkt darauf würde nach dem ersten Update an einem
    // verwaisten, unsichtbaren Element hängen bleiben und Klicks auf die
    // neu eingefügten (sichtbaren) Buttons gar nicht mehr empfangen —
    // genau das ließ preventDefault() beim zweiten Klick unbemerkt
    // wirkungslos werden. #cartOverlay bleibt stabil, nur sein Inhalt
    // ändert sich.
    overlay.addEventListener('click', function (e) {
      var btn = e.target.closest('.qty-plus, .qty-minus, .cart-item-remove');
      if (!btn) return;
      e.preventDefault();
      var key = btn.getAttribute('data-key');
      var neueMenge = btn.getAttribute('data-neue-menge');
      if (!key || neueMenge === null) return;

      function aenderungAusfuehren() {
        // Sofortige Rückmeldung: die Anfrage an Shopify braucht einen
        // Moment, ohne Reaktion wirkt der Klick verschluckt. Die Zeile
        // wird ausgegraut und für weitere Klicks gesperrt (verhindert
        // versehentliches Doppel-Löschen), der Mülleimer wird zum
        // Ladekreis. Beides verschwindet automatisch, weil das Panel
        // danach ohnehin neu aufgebaut wird.
        var zeile = btn.closest('.cart-item');
        if (zeile) zeile.classList.add('is-wird-bearbeitet');
        if (btn.classList.contains('cart-item-remove')) {
          btn.classList.add('is-laedt');
        }
        cartPanelWarteschlange.push({ key: key, neueMenge: parseInt(neueMenge, 10) });
        cartPanelNaechsteAusFuehren();
      }

      // Kernbauteil-Schutz: Gehört die Zeile zu einer PC-Konfiguration,
      // vor dem ENTFERNEN einmal nachfragen — sonst fehlt dem System
      // hinterher unbemerkt z.B. das Netzteil. War: window.confirm()
      // (grauer Browser-Kasten) — jetzt der NEXUS-Dialog, mit eigenem
      // Wortlaut für die Montage-Position.
      if (btn.classList.contains('cart-item-remove')) {
        var konfigZeile = btn.closest('.cart-item');
        if (konfigZeile && konfigZeile.querySelector('.cart-item-konfig')) {
          window.nexusBestaetigen(
            window.nexusKonfigEntfernenDialog(konfigZeile.getAttribute('data-zusatz-art'))
          ).then(function (bestaetigt) {
            if (bestaetigt) aenderungAusfuehren();
          });
          return;
        }
      }

      aenderungAusfuehren();
    });

    function openCart() {
      overlay.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      recalculate();
    }

    function closeCart() {
      overlay.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', openCart);
    // War: closeBtn.addEventListener('click', closeCart) — der Knopf liegt
    // INNERHALB von #cartPanel (siehe snippets/overlays.liquid) und wird
    // beim Aktualisieren per innerHTML durch ein neues Element ersetzt.
    // Der Handler hing danach an einem entfernten Element, das X reagierte
    // nicht mehr. Delegation auf dem Overlay überlebt jeden Austausch.
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target.closest('#cartCloseBtn')) {
          e.preventDefault();
          closeCart();
        }
      });
    }
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeCart();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCart();
    });

    // nexusWarenkorbAktualisieren liegt bewusst außerhalb dieses Blocks
    // (damit es nicht von der Abbruchbedingung oben abhängt) und kommt
    // deshalb nicht an recalculate() heran. Nach dem Panel-Austausch muss
    // aber neu gerechnet werden, sonst bleiben Zwischensumme, Artikelzahl
    // und Versandfortschritt auf dem alten Stand stehen. Verbindung über
    // ein Ereignis statt über eine weitere globale Funktion.
    document.addEventListener('nexus:warenkorb-aktualisiert', function () {
      recalculate();
    });

    // Initial calculation on page load so the header badge is accurate
    recalculate();
  })();

// ---- Kontobereich: Kopfkarte ----
// Bewusst ein EIGENER Block, nicht Teil von initAccountPanel: Dort wird
// früh abgebrochen, wenn der Kopfbereich fehlt — die Kopfkarte im
// Kundenkonto bliebe dann leer, obwohl sie damit nichts zu tun hat.
  (function initKontoKopf() {
    var avatar = document.getElementById('seitenleisteAvatar');
    if (!avatar) return;

    function fuellen(kunde) {
      var name = document.getElementById('seitenleisteName');
      var mail = document.getElementById('seitenleisteMail');
      var v = (kunde.vorname || '').trim().charAt(0);
      var n = (kunde.nachname || '').trim().charAt(0);
      avatar.textContent = (v + n).toUpperCase() || '?';
      if (name) name.textContent = ((kunde.vorname || '') + ' ' + (kunde.nachname || '')).trim() || 'Mein Konto';
      if (mail) mail.textContent = kunde.email || '';

      // Kennzahl "Unterwegs" nur zeigen, wenn tatsächlich etwas unterwegs
      // ist — sonst stünde dort dauerhaft eine Null.
      var offen = parseInt(kunde.bestellungen_offen, 10);
      var block = document.getElementById('kennzahlOffenBlock');
      var zahl = document.getElementById('kennzahlOffen');
      if (block && zahl) {
        if (offen > 0) { zahl.textContent = offen; block.hidden = false; }
        else { block.hidden = true; }
      }
    }

    document.addEventListener('nexus:kunde-geladen', function (e) {
      if (e.detail && e.detail.kunde) fuellen(e.detail.kunde);
    });

    // Die Kennzahlen "Bestellungen" und "Adressen" kennen nur die
    // jeweiligen Seiten (konto.js, adressen.js). Sie melden sie hierher,
    // damit keine zusätzliche Abfrage nötig ist.
    document.addEventListener('nexus:kennzahl', function (e) {
      if (!e.detail) return;
      var ziel = document.getElementById(e.detail.id);
      if (ziel) ziel.textContent = e.detail.wert;
      // Die Seite hat die Zahl gerade frisch geladen — merken, damit sie
      // auf den anderen Seiten sofort stimmt und dort keine Abfrage nötig
      // ist. Überschreibt einen möglicherweise veralteten Wert.
      if (e.detail.id === 'kennzahlBestellungen') zahlenMerken('bestellungen', e.detail.wert);
      if (e.detail.id === 'kennzahlAdressen') zahlenMerken('adressen', e.detail.wert);
    });

    // Kennzahlen nachladen, wenn die aktuelle Seite sie nicht selbst
    // meldet.
    //
    // War: Nur die jeweilige Seite meldete ihre Zahl (konto.js die
    // Bestellungen, adressen.js die Adressen). Auf der Profilseite lädt
    // aber keine von beiden — dort stand dauerhaft ein Strich, obwohl die
    // Kopfkarte auf allen drei Seiten gleich aussieht.
    //
    // Die Zahlen werden für kurze Zeit gemerkt, damit nicht bei jedem
    // Seitenwechsel neu abgefragt wird.
    var ZAHLEN_SCHLUESSEL = 'nexus_kunde_zahlen';
    var ZAHLEN_DAUER = 5 * 60 * 1000;

    function zahlSetzen(id, wert) {
      var ziel = document.getElementById(id);
      if (ziel) ziel.textContent = wert;
    }

    function zahlenMerken(feld, wert) {
      try {
        var roh = sessionStorage.getItem(ZAHLEN_SCHLUESSEL);
        var z = roh ? JSON.parse(roh) : {};
        z[feld] = wert;
        z.zeit = Date.now();
        sessionStorage.setItem(ZAHLEN_SCHLUESSEL, JSON.stringify(z));
      } catch (e) {}
    }

    function zahlenNachladen() {
      var token = '';
      try { token = localStorage.getItem('nexus_kunde_token') || ''; } catch (e) {}
      if (!token) return;

      // Gemerkte Zahlen zuerst — spart die Abfrage beim Seitenwechsel.
      var gemerkt = null;
      try {
        var roh = sessionStorage.getItem(ZAHLEN_SCHLUESSEL);
        if (roh) {
          var z = JSON.parse(roh);
          if (z && z.zeit && (Date.now() - z.zeit) < ZAHLEN_DAUER) gemerkt = z;
        }
      } catch (e) {}

      // Gemerkte Werte zeigen, damit sofort etwas dasteht — sie gelten
      // aber nur als Zwischenlösung. Lädt die Seite selbst eine der Listen
      // (konto.js oder adressen.js), meldet sie die frische Zahl über
      // nexus:kennzahl und überschreibt den gemerkten Wert.
      //
      // WICHTIG: Nur setzen, wenn dort noch der Platzhalter steht. Sonst
      // würde ein gemerkter, veralteter Wert eine gerade frisch geladene
      // Zahl überschreiben — genau das passierte auf der Adressseite, wenn
      // sich der Bestand geändert hatte.
      function zahlSetzenWennLeer(id, wert) {
        var ziel = document.getElementById(id);
        if (!ziel) return;
        var jetzt = ziel.textContent.trim();
        if (jetzt === '' || jetzt === '–' || jetzt === '-') ziel.textContent = wert;
      }

      if (gemerkt) {
        if (typeof gemerkt.bestellungen === 'number') zahlSetzenWennLeer('kennzahlBestellungen', gemerkt.bestellungen);
        if (typeof gemerkt.adressen === 'number') zahlSetzenWennLeer('kennzahlAdressen', gemerkt.adressen);
      }

      // Die Seite lädt eine der Listen ohnehin selbst? Dann diese Abfrage
      // überspringen — sonst würde zweimal dasselbe geholt.
      var ladeSelbst = {
        bestellungen: !!document.getElementById('kontoBestellungen'),
        adressen: !!document.getElementById('adressenListe')
      };

      // Nur abfragen, was weder gemerkt ist noch von der Seite geladen wird.
      if (!ladeSelbst.bestellungen && (!gemerkt || typeof gemerkt.bestellungen !== 'number')) {
        fetch('/apps/konto/bestellungen?sitzung=' + encodeURIComponent(token))
          .then(function (a) { return a.ok ? a.json() : null; })
          .then(function (d) {
            if (d && d.ok === true) {
              var n = (d.bestellungen || []).length;
              zahlSetzen('kennzahlBestellungen', n);
              zahlenMerken('bestellungen', n);
            }
          })
          .catch(function () { /* Strich bleibt stehen, kein Drama */ });
      }

      if (!ladeSelbst.adressen && (!gemerkt || typeof gemerkt.adressen !== 'number')) {
        fetch('/apps/konto/adressen?sitzung=' + encodeURIComponent(token))
          .then(function (a) { return a.ok ? a.json() : null; })
          .then(function (d) {
            if (d && d.ok === true) {
              var n = (d.adressen || []).length;
              zahlSetzen('kennzahlAdressen', n);
              zahlenMerken('adressen', n);
            }
          })
          .catch(function () { /* Strich bleibt stehen */ });
      }
    }

    zahlenNachladen();

    // Falls der Kopfbereich fehlt oder seine Abfrage nicht läuft: selbst
    // laden. Der Zwischenspeicher verhindert eine doppelte Abfrage.
    try {
      var roh = sessionStorage.getItem('nexus_kunde_daten');
      if (roh) {
        var c = JSON.parse(roh);
        if (c && c.kunde) { fuellen(c.kunde); return; }
      }
    } catch (e) {}

    var token = '';
    try { token = localStorage.getItem('nexus_kunde_token') || ''; } catch (e) {}
    if (!token) return;

    fetch('/apps/konto/ich?sitzung=' + encodeURIComponent(token))
      .then(function (a) { if (!a.ok) throw new Error('nicht ok'); return a.json(); })
      .then(function (d) {
        if (d && d.ok === true && d.customer) {
          fuellen(d.customer);
          try {
            sessionStorage.setItem('nexus_kunde_daten',
              JSON.stringify({ zeit: Date.now(), kunde: d.customer }));
          } catch (e) {}
        }
      })
      .catch(function () { /* Kopfkarte bleibt dann bei den Platzhaltern */ });
  })();

// ---- Account panel (Willkommens-Dropdown) ----
  (function initAccountPanel() {
    var trigger = document.getElementById('accountTrigger');
    var panel = document.getElementById('accountPanel');
    var panelAngemeldet = document.getElementById('accountPanelLoggedIn');
    if (!trigger || !panel) return;

    // Anmeldezustand prüfen und das passende Panel zeigen.
    //
    // War: Es gab schon immer ZWEI Panels im Kopfbereich — eines für Gäste
    // und eines für Angemeldete. Umgeschaltet wurde aber nie, weshalb auch
    // nach erfolgreicher Anmeldung dauerhaft "Anmelden / Konto erstellen"
    // dastand und der Kunde nicht ins Profil kam.
    //
    // Die Anmeldung läuft über die NEXUS-App, nicht über Shopify — deshalb
    // ist Shopifys customer-Objekt hier leer und wir fragen /apps/konto/ich
    // mit dem gespeicherten Token ab.
    //
    // Das Ergebnis wird für kurze Zeit in sessionStorage gemerkt, damit
    // nicht bei jedem Seitenaufruf neu gefragt wird.
    var TOKEN_SCHLUESSEL = 'nexus_kunde_token';
    var CACHE_SCHLUESSEL = 'nexus_kunde_daten';
    var CACHE_DAUER = 5 * 60 * 1000; // 5 Minuten

    function tokenLesen() {
      try { return localStorage.getItem(TOKEN_SCHLUESSEL) || ''; }
      catch (e) { return ''; }
    }

    function initialen(vorname, nachname) {
      var v = (vorname || '').trim().charAt(0);
      var n = (nachname || '').trim().charAt(0);
      return (v + n).toUpperCase() || '?';
    }

    function panelBefuellen(kunde) {
      if (!panelAngemeldet) return;

      var avatar = panelAngemeldet.querySelector('.account-avatar');
      var name = panelAngemeldet.querySelector('.account-loggedin-info h4');
      var mail = panelAngemeldet.querySelector('.account-loggedin-info span');
      var abzeichen = panelAngemeldet.querySelector('.account-menu-badge');

      var vollerName = ((kunde.vorname || '') + ' ' + (kunde.nachname || '')).trim();
      if (avatar) avatar.textContent = initialen(kunde.vorname, kunde.nachname);
      if (name) name.textContent = vollerName || 'Mein Konto';
      if (mail) mail.textContent = kunde.email || '';

      // "1 unterwegs" nur zeigen, wenn tatsächlich etwas unterwegs ist.
      if (abzeichen) {
        var offen = parseInt(kunde.bestellungen_offen, 10);
        if (offen > 0) {
          abzeichen.textContent = offen + (offen === 1 ? ' unterwegs' : ' unterwegs');
          abzeichen.hidden = false;
        } else {
          abzeichen.hidden = true;
        }
      }

      panel.classList.add('nx-panel-aus');
      panelAngemeldet.classList.add('nx-panel-aktiv');

      seitenleisteFuellen(kunde);
    }

    function angemeldetPruefen() {
      var token = tokenLesen();
      if (!token || !panelAngemeldet) return;

      // Zwischengespeicherte Daten nutzen, falls frisch genug.
      try {
        var roh = sessionStorage.getItem(CACHE_SCHLUESSEL);
        if (roh) {
          var c = JSON.parse(roh);
          if (c && c.zeit && (Date.now() - c.zeit) < CACHE_DAUER && c.kunde) {
            panelBefuellen(c.kunde);
            return;
          }
        }
      } catch (e) { /* egal, dann eben frisch abfragen */ }

      fetch('/apps/konto/ich?sitzung=' + encodeURIComponent(token))
        .then(function (antwort) {
          if (antwort.status === 401) {
            // Token abgelaufen oder ungültig — still verwerfen, der Kunde
            // sieht ganz normal das Gäste-Panel.
            try {
              localStorage.removeItem(TOKEN_SCHLUESSEL);
              sessionStorage.removeItem(CACHE_SCHLUESSEL);
              sessionStorage.removeItem('nexus_kunde_zahlen');
            } catch (e) {}
            throw new Error('nicht angemeldet');
          }
          if (!antwort.ok) throw new Error('Abfrage fehlgeschlagen');
          return antwort.json();
        })
        .then(function (daten) {
          if (!daten || daten.ok !== true || !daten.customer) throw new Error('unerwartete Antwort');
          panelBefuellen(daten.customer);
          try {
            sessionStorage.setItem(CACHE_SCHLUESSEL,
              JSON.stringify({ zeit: Date.now(), kunde: daten.customer }));
          } catch (e) {}
        })
        .catch(function () {
          // Kein Aufheben: Ohne gültige Antwort bleibt das Gäste-Panel
          // sichtbar. Nichts sieht kaputt aus.
        });
    }

    // Abmelden. Wichtig laut App-Team: Der Endpunkt macht technisch ALLE
    // Sitzungen dieses Kontos ungültig, nicht nur die aktuelle. Deshalb
    // wird der Kunde darauf hingewiesen — sonst wundert er sich, warum er
    // auch auf dem Handy abgemeldet ist.
    function abmelden(e) {
      if (e) e.preventDefault();
      var token = tokenLesen();
      function aufraeumen() {
        try {
          localStorage.removeItem(TOKEN_SCHLUESSEL);
          sessionStorage.removeItem(CACHE_SCHLUESSEL);
          // Auch die zwischengespeicherten Kennzahlen (Bestell-/Adress-
          // Anzahl) entfernen — sonst sähe der nächste Nutzer im selben
          // Browser bis zu 5 Minuten fremde Zahlen.
          sessionStorage.removeItem('nexus_kunde_zahlen');
        } catch (fehler) {}
        window.location.href = '/';
      }
      if (!token) { aufraeumen(); return; }
      fetch('/apps/konto/abmelden?sitzung=' + encodeURIComponent(token), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sitzung: token })
      })
        .then(aufraeumen)
        // Auch bei Netzwerkfehler lokal abmelden — sonst bliebe der
        // Kunde scheinbar angemeldet, obwohl er es nicht sein will.
        .catch(aufraeumen);
    }

    // Zwei Stellen zum Abmelden: das Kontomenü im Kopfbereich und die
    // Seitenleiste im Kundenkonto. Beide nutzen dieselbe Funktion —
    // vorher führte der Link in der Seitenleiste nur zur Startseite,
    // ohne tatsächlich abzumelden.
    ['accountDemoLogoutBtn', 'kontoSeitenleisteAbmelden'].forEach(function (id) {
      var link = document.getElementById(id);
      if (link) link.addEventListener('click', abmelden);
    });

    // Seitenleiste im Kundenkonto mit Name und E-Mail füllen — die kamen
    // vorher aus Shopifys customer-Objekt und blieben dadurch leer.
    function seitenleisteFuellen(kunde) {
      // Die Kopfkarte füllt sich über nexus:kunde-geladen selbst — hier
      // nur das Ereignis auslösen, damit beides nicht doppelt passiert.
      document.dispatchEvent(new CustomEvent('nexus:kunde-geladen', { detail: { kunde: kunde } }));
    }

    // Sofort umschalten, wenn sich jemand gerade angemeldet hat — ohne die
    // Seite neu zu laden. nexus-konto.js löst dieses Ereignis aus, sobald
    // die Anmeldung erfolgreich war und die Kundendaten vorliegen.
    document.addEventListener('nexus:angemeldet', function (e) {
      var kunde = e && e.detail ? e.detail.kunde : null;
      if (kunde) panelBefuellen(kunde);
      else angemeldetPruefen();
    });

    angemeldetPruefen();

    // Öffnen/Schließen betrifft beide Panels — sichtbar ist ohnehin nur
    // das jeweils passende (siehe nx-panel-aus / nx-panel-aktiv).
    function openPanel() {
      panel.classList.add('is-open');
      if (panelAngemeldet) panelAngemeldet.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function closePanel() {
      panel.classList.remove('is-open');
      if (panelAngemeldet) panelAngemeldet.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    function togglePanel() {
      if (panel.classList.contains('is-open')) {
        closePanel();
      } else {
        openPanel();
      }
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      togglePanel();
    });

    document.addEventListener('click', function (e) {
      if (!panel.contains(e.target) && e.target !== trigger) {
        closePanel();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });

// ---- Cookie consent banner ----
    (function initCookieBanner() {
      var STORAGE_KEY = 'nexus-cookie-consent';
      var banner = document.getElementById('cookieBanner');
      var settingsOverlay = document.getElementById('cookieSettingsOverlay');
      var acceptBtn = document.getElementById('cookieAcceptBtn');
      var rejectBtn = document.getElementById('cookieRejectBtn');
      var openSettingsBtn = document.getElementById('cookieOpenSettingsBtn');
      var settingsClose = document.getElementById('cookieSettingsClose');
      var settingsRejectBtn = document.getElementById('cookieSettingsRejectBtn');
      var settingsSaveBtn = document.getElementById('cookieSettingsSaveBtn');
      var statsToggle = document.getElementById('cookieToggleStats');
      var statsCheckbox = document.getElementById('cookieCheckboxStats');
      var marketingToggle = document.getElementById('cookieToggleMarketing');
      var marketingCheckbox = document.getElementById('cookieCheckboxMarketing');
      if (!banner) return;

      function getStoredConsent() {
        try {
          var raw = localStorage.getItem(STORAGE_KEY);
          return raw ? JSON.parse(raw) : null;
        } catch (e) {
          return null;
        }
      }

      function storeConsent(consent) {
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
        } catch (e) { /* localStorage unavailable — consent simply won't persist across visits */ }
      }

      function hideBanner() {
        banner.classList.remove('is-visible');
      }

      function closeSettings() {
        if (settingsOverlay) {
          settingsOverlay.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      }

      function openSettings() {
        if (settingsOverlay) {
          settingsOverlay.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      }

      // Show the banner only if no choice has been recorded yet for this browser
      if (!getStoredConsent()) {
        setTimeout(function () { banner.classList.add('is-visible'); }, 400);
      }

      if (acceptBtn) {
        acceptBtn.addEventListener('click', function () {
          storeConsent({ necessary: true, statistics: true, marketing: true });
          hideBanner();
        });
      }
      if (rejectBtn) {
        rejectBtn.addEventListener('click', function () {
          storeConsent({ necessary: true, statistics: false, marketing: false });
          hideBanner();
        });
      }
      if (openSettingsBtn) openSettingsBtn.addEventListener('click', openSettings);
      if (settingsClose) settingsClose.addEventListener('click', closeSettings);
      if (settingsOverlay) {
        settingsOverlay.addEventListener('click', function (e) {
          if (e.target === settingsOverlay) closeSettings();
        });
      }

      // Category toggles inside the settings popup
      if (statsToggle && statsCheckbox) {
        statsToggle.addEventListener('click', function () {
          statsCheckbox.checked = !statsCheckbox.checked;
        });
      }
      if (marketingToggle && marketingCheckbox) {
        marketingToggle.addEventListener('click', function () {
          marketingCheckbox.checked = !marketingCheckbox.checked;
        });
      }

      if (settingsRejectBtn) {
        settingsRejectBtn.addEventListener('click', function () {
          if (statsCheckbox) statsCheckbox.checked = false;
          if (marketingCheckbox) marketingCheckbox.checked = false;
          storeConsent({ necessary: true, statistics: false, marketing: false });
          closeSettings();
          hideBanner();
        });
      }
      if (settingsSaveBtn) {
        settingsSaveBtn.addEventListener('click', function () {
          storeConsent({
            necessary: true,
            statistics: statsCheckbox ? statsCheckbox.checked : false,
            marketing: marketingCheckbox ? marketingCheckbox.checked : false
          });
          closeSettings();
          hideBanner();
        });
      }
    })();

// ---- Passwort-vergessen-Popup entfernt: Der Shop ist passwortlos
// (Anmeldung per E-Mail-Code über die NEXUS-App). Das alte Popup
// postete an Shopifys abgeschaltetes natives Kundenkonto-System und
// meldete trotzdem Erfolg — es hätte nie eine E-Mail verschickt.

  })();

// ---- Mega menu (Kategorien dropdown) ----
  (function initMegaMenu() {
    var trigger = document.getElementById('megaMenuTrigger');
    var menu = document.getElementById('megaMenu');
    if (!trigger || !menu) return;

    function openMenu() {
      menu.classList.add('is-open');
      trigger.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      trigger.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    function toggleMenu() {
      if (menu.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      toggleMenu();
    });

    // Capture-Phase: feuert VOR allen anderen Klick-Handlern und kann
    // nicht per stopPropagation unterdrueckt werden. So schliesst das
    // Menue garantiert bei jedem Klick ausserhalb — auch beim Klick auf
    // den zweiten Menue-Trigger (IT & Business), der die Weitergabe
    // selbst stoppt.
    document.addEventListener('click', function (e) {
      if (!menu.contains(e.target) && !trigger.contains(e.target)) {
        closeMenu();
      }
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  })();

// ---- Dark mode toggle ----
  (function initThemeToggle() {
    var STORAGE_KEY = 'nexus-theme';
    var toggleBtn = document.getElementById('themeToggle');
    var htmlEl = document.documentElement;

    function applyTheme(theme) {
      if (theme === 'dark') {
        htmlEl.setAttribute('data-theme', 'dark');
      } else {
        htmlEl.removeAttribute('data-theme');
      }
    }

    // On load: use saved preference, otherwise fall back to system setting
    var saved = null;
    try { saved = localStorage.getItem(STORAGE_KEY); } catch (e) {}

    // Standard ist HELL (Entscheidung Halil 25.10.2026) — die
    // System-Einstellung wird bewusst ignoriert; dunkel nur bei
    // eigener Wahl ueber den Schalter.
    if (saved === 'dark' || saved === 'light') {
      applyTheme(saved);
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        var isDark = htmlEl.getAttribute('data-theme') === 'dark';
        var next = isDark ? 'light' : 'dark';
        applyTheme(next);
        try { localStorage.setItem(STORAGE_KEY, next); } catch (e) {}
      });
    }
  })();

// Wandelt Zeichen um, die im HTML eine Sonderbedeutung haben. Nötig
// überall dort, wo Text per innerHTML eingesetzt wird und nicht aus dem
// Theme selbst stammt — etwa Suchbegriffe des Nutzers oder gespeicherter
// Suchverlauf aus dem Browserspeicher. Ohne das könnte ein präparierter
// Eintrag Code in die Seite einschleusen.
  function nxTextEntschaerfen(text) {
    var d = document.createElement('div');
    d.textContent = String(text == null ? '' : text);
    return d.innerHTML;
  }

// ---- Search overlay: live product search, popular terms, recent history ----
  (function initSearchOverlay() {
    var trigger = document.getElementById('searchTrigger');
    var overlay = document.getElementById('searchOverlay');
    var closeBtn = document.getElementById('searchCloseBtn');
    var input = document.getElementById('searchInput');
    var body = document.getElementById('searchBody');
    if (!trigger || !overlay || !input || !body) return;

    var STORAGE_KEY = 'nexus-recent-searches';
    var maxHistory = 5;

    // Echte Kategorien statt erfundener Suchbegriffe.
    var popularTerms = ['Prozessor', 'Grafikkarte', 'Mainboard', 'Arbeitsspeicher', 'SSD'];

    // Small demo product catalog to search against (would be real product data in Shopify)
    // Shopifys Suchvorschläge. Die Adresse durchsucht Titel, Beschreibung,
    // Marke und Produkttyp — dadurch findet "threadripper" auch Produkte, die
    // den Begriff nicht wörtlich im Titel führen.
    // Vorher stand hier eine feste Liste mit acht Beispielprodukten
    // (iPhone, PlayStation, RTX 4080), die nie den echten Katalog durchsuchte.
    var suchAnfrageLaeuft = null;

    function produkteSuchen(begriff) {
      var adresse = '/search/suggest.json?q=' + encodeURIComponent(begriff) +
                    '&resources[type]=product&resources[limit]=8' +
                    '&resources[options][unavailable_products]=last' +
                    '&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku';
      return fetch(adresse)
        .then(function (a) { return a.ok ? a.json() : null; })
        .then(function (d) {
          if (!d || !d.resources || !d.resources.results) return [];
          return (d.resources.results.products || [])
            // Produkte mit dem Tag "versteckt" (z.B. der Montageservice)
            // gehören auch nicht in die Suchvorschläge.
            .filter(function (p) {
              return !(p.tags && p.tags.indexOf('versteckt') !== -1);
            })
            .map(function (p) {
              // Die Suggest-API liefert den Preis als "1199.00" —
              // fürs Overlay deutsch formatieren wie überall sonst.
              var preisRoh = parseFloat(p.price);
              return {
                name: p.title,
                price: isFinite(preisRoh)
                  ? preisRoh.toLocaleString('de-DE',
                      { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
                  : '',
                img: p.featured_image ? p.featured_image.url : null,
                url: p.url,
                tags: p.tags || []
              };
            });
        })
        .catch(function () { return []; });
    }

    function getHistory() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (e) {
        return [];
      }
    }

    function addToHistory(term) {
      if (!term.trim()) return;
      var history = getHistory().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
      history.unshift(term);
      history = history.slice(0, maxHistory);
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(history)); } catch (e) {}
    }

    function clearHistory() {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      renderIdleState();
    }

    // Hebt die Fundstelle im Produktnamen hervor. Das Ergebnis wird per
    // innerHTML eingesetzt — deshalb werden ALLE Textteile einzeln
    // entschärft, bevor das <span> dazwischenkommt. Vorher wurden
    // Produktname und Suchbegriff ungeprüft zusammengesetzt.
    function highlightMatch(text, query) {
      var sicher = nxTextEntschaerfen(text);
      if (!query) return sicher;
      var idx = text.toLowerCase().indexOf(query.toLowerCase());
      if (idx === -1) return sicher;
      return nxTextEntschaerfen(text.slice(0, idx)) +
             '<span class="search-result-highlight">' +
             nxTextEntschaerfen(text.slice(idx, idx + query.length)) +
             '</span>' +
             nxTextEntschaerfen(text.slice(idx + query.length));
    }

    function renderChipRow(label, terms, iconSvg, isHistory) {
      var section = document.createElement('div');
      section.className = 'search-section';

      var labelRow = document.createElement('div');
      labelRow.className = 'search-section-label';
      var labelText = document.createElement('span');
      labelText.textContent = label;
      labelRow.appendChild(labelText);

      if (isHistory) {
        var clearLink = document.createElement('span');
        clearLink.className = 'search-clear-history';
        clearLink.textContent = 'Verlauf löschen';
        clearLink.addEventListener('click', clearHistory);
        labelRow.appendChild(clearLink);
      }

      section.appendChild(labelRow);

      var chipRow = document.createElement('div');
      chipRow.className = 'search-chip-row';

      terms.forEach(function (term) {
        var chip = document.createElement('button');
        chip.className = 'search-chip' + (isHistory ? ' recent' : '');
        chip.innerHTML = iconSvg + '<span>' + nxTextEntschaerfen(term) + '</span>';
        chip.addEventListener('click', function () {
          input.value = term;
          input.dispatchEvent(new Event('input'));
        });
        chipRow.appendChild(chip);
      });

      section.appendChild(chipRow);
      return section;
    }

    var clockIcon = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
    var trendIcon = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/></svg>';

    function renderIdleState() {
      body.innerHTML = '';
      var history = getHistory();

      if (history.length > 0) {
        body.appendChild(renderChipRow('Zuletzt gesucht', history, clockIcon, true));
      }
      body.appendChild(renderChipRow('Beliebte Suchanfragen', popularTerms, trendIcon, false));
    }

    function renderResults(query) {
      // Erst den Suchlauf anstoßen, dann zeichnen. Solange nichts da ist,
      // bleibt der bisherige Inhalt stehen statt kurz leer zu blitzen.
      if (suchAnfrageLaeuft) suchAnfrageLaeuft = null;
      var dieseAnfrage = {};
      suchAnfrageLaeuft = dieseAnfrage;
      produkteSuchen(query).then(function (gefunden) {
        if (suchAnfrageLaeuft !== dieseAnfrage) return;  // eine neuere Eingabe hat übernommen
        ergebnisseZeichnen(query, gefunden);
      });
    }

    function ergebnisseZeichnen(query, matches) {
      body.innerHTML = '';

      var section = document.createElement('div');
      section.className = 'search-section';

      var labelRow = document.createElement('div');
      labelRow.className = 'search-section-label';
      var labelText = document.createElement('span');
      labelText.textContent = matches.length > 0 ? matches.length + ' Ergebnisse' : 'Keine Ergebnisse';
      labelRow.appendChild(labelText);
      section.appendChild(labelRow);

      if (matches.length === 0) {
        var empty = document.createElement('div');
        empty.className = 'search-empty-state';
        empty.innerHTML = 'Keine Produkte gefunden für "' + nxTextEntschaerfen(query) + '".<br>Schau dir stattdessen unsere <a href="/collections/all">gesamten Shop</a> oder <a href="/collections/angebote">aktuellen Angebote</a> an.';
        section.appendChild(empty);
      } else {
        matches.forEach(function (p) {
          var item = document.createElement('a');
          item.href = p.url || '/collections/all';
          item.className = 'search-result-item';

          var imgWrap = document.createElement('div');
          imgWrap.className = 'search-result-img';
          if (p.img) {
            var img = document.createElement('img');
            img.src = p.img;
            img.alt = p.name;
            imgWrap.appendChild(img);
          }

          var info = document.createElement('div');
          info.className = 'search-result-info';
          var title = document.createElement('h4');
          title.innerHTML = highlightMatch(p.name, query);
          var price = document.createElement('span');
          price.textContent = p.price;
          info.appendChild(title);
          info.appendChild(price);

          item.appendChild(imgWrap);
          item.appendChild(info);
          item.addEventListener('click', function () { addToHistory(query); });
          section.appendChild(item);
        });
      }

      body.appendChild(section);
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      if (query === '') {
        renderIdleState();
      } else {
        renderResults(query);
      }
    });

    input.addEventListener('keydown', function (e) {
      // Enter führte bisher nur die Verlaufsliste — ohne Weiterleitung zur
      // Ergebnisseite blieb der Kunde einfach im Fenster stehen.
      if (e.key !== 'Enter') return;
      var begriff = input.value.trim();
      if (!begriff) return;
      addToHistory(begriff);
      window.location.href = '/search?q=' + encodeURIComponent(begriff) + '&type=product';
    });

    function openSearch() {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      renderIdleState();
      setTimeout(function () { input.focus(); }, 50);
    }

    function closeSearch() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      input.value = '';
    }

    trigger.addEventListener('click', openSearch);
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeSearch();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
    });
  })();

// ---- Live open/closed status badge based on business hours (Mo-Fr 11:30-18:00, Sa 12:00-17:30) ----
  (function initStatusBadge() {
    var dot = document.getElementById('statusDot');
    var text = document.getElementById('statusText');
    if (!dot || !text) return;

    var now = new Date();
    var day = now.getDay(); // 0 = Sunday, 1-5 = Monday-Friday, 6 = Saturday
    var minutesNow = now.getHours() * 60 + now.getMinutes();

    var isWeekday = day >= 1 && day <= 5;
    var isSaturday = day === 6;

    var weekdayOpen = 11 * 60 + 30;   // 11:30
    var weekdayClose = 18 * 60;       // 18:00
    var saturdayOpen = 12 * 60;       // 12:00
    var saturdayClose = 17 * 60 + 30; // 17:30

    var isWithinWeekdayHours = isWeekday && minutesNow >= weekdayOpen && minutesNow < weekdayClose;
    var isWithinSaturdayHours = isSaturday && minutesNow >= saturdayOpen && minutesNow < saturdayClose;
    var isOnline = isWithinWeekdayHours || isWithinSaturdayHours;

    if (isOnline) {
      dot.classList.remove('offline');
      dot.classList.add('online');
      text.textContent = 'Wir sind gerade online';
    } else {
      dot.classList.remove('online');
      dot.classList.add('offline');
      text.textContent = 'Gerade offline – Mo–Fr 11:30–18:00 Uhr, Sa 12:00–17:30 Uhr';
    }
  })();

// ---- FAQ accordion ----
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var wasOpen = item.classList.contains('is-open');
      document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('is-open'); });
      if (!wasOpen) item.classList.add('is-open');
    });
  });
// ---- Produktseite: Galerie, Mengenwahl, Variantenwechsel ----
(function () {
  // Vorschaubild anklicken -> großes Bild tauschen
  var haupt = document.getElementById('productMainImage');
  document.querySelectorAll('.product-gallery-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var quelle = thumb.getAttribute('data-img');
      if (!quelle || !haupt) return;
      haupt.src = quelle;
      document.querySelectorAll('.product-gallery-thumb').forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    });
  });

  // Menge über die Plus/Minus-Knöpfe
  var mengeFeld = document.getElementById('mengeFeld');
  // Nur die Mengen-Knöpfe der PRODUKTSEITE (die mit data-qty). Die
  // Warenkorb-Panel-Knöpfe tragen dieselbe Klasse .qty-btn, aber kein
  // data-qty — ohne diese Eingrenzung würde ein "+" im Panel nebenbei
  // still die Menge im Produktformular verringern.
  document.querySelectorAll('.qty-btn[data-qty]').forEach(function (knopf) {
    knopf.addEventListener('click', function () {
      if (!mengeFeld) return;
      var wert = parseInt(mengeFeld.value, 10) || 1;
      wert = knopf.getAttribute('data-qty') === 'plus' ? wert + 1 : Math.max(1, wert - 1);
      mengeFeld.value = wert;
    });
  });

  // Variantenwechsel: Preis mitziehen. Die Anzeige darf nicht auf dem
  // Preis der ersten Variante stehenbleiben, wenn eine andere gewählt wird.
  // Variantenwahl: anklickbare Chips statt eines nativen <select> (siehe
  // produkt.liquid). Das versteckte <select> bleibt bestehen, weil Shopifys
  // Warenkorb-Formular den Feldnamen "id" braucht — ein Klick auf einen Chip
  // stellt es nur im Hintergrund um, der Kunde sieht es nie.
  var verstecktesSelect = document.getElementById('variantenAuswahl');
  var chips = document.querySelectorAll('.product-variant-chip');
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      if (chip.disabled) return;
      chips.forEach(function (c) { c.classList.remove('is-selected'); });
      chip.classList.add('is-selected');

      var variantenId = chip.getAttribute('data-variant-id');
      if (verstecktesSelect) {
        verstecktesSelect.value = variantenId;
        verstecktesSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var preisAnzeige = document.getElementById('preisAnzeige');
      var preis = chip.getAttribute('data-price');
      if (preisAnzeige && preis) preisAnzeige.textContent = preis;

      var skuAnzeige = document.getElementById('produktSku');
      var sku = chip.getAttribute('data-sku');
      if (skuAnzeige) {
        if (sku) {
          skuAnzeige.textContent = 'Art.-Nr. ' + window.nexusArtikelAnzeige(sku);
          skuAnzeige.style.display = '';
        } else {
          skuAnzeige.style.display = 'none';
        }
      }
    });
  });
})();

// ---- Kundenkonto: Adressformulare ein- und ausklappen ----
(function () {
  var neuBtn = document.getElementById('neueAdresseBtn');
  var neuForm = document.getElementById('neueAdresseFormular');
  if (neuBtn && neuForm) {
    neuBtn.addEventListener('click', function () {
      neuForm.hidden = !neuForm.hidden;
      if (!neuForm.hidden) neuForm.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  document.querySelectorAll('.account-address-edit').forEach(function (knopf) {
    knopf.addEventListener('click', function () {
      var id = knopf.getAttribute('data-adresse-id');
      var formular = document.getElementById('adresseFormular' + id);
      if (formular) formular.hidden = !formular.hidden;
    });
  });

  // Löschen ist nicht rückgängig zu machen - deshalb einmal nachfragen.
  // War: window.confirm (grauer Browser-Kasten). Jetzt der NEXUS-Dialog —
  // der kann den Klick nicht anhalten wie confirm(), deshalb wird der
  // Klick immer erst gestoppt und nach Bestätigung programmatisch
  // wiederholt (markiert über data-nexus-bestaetigt, damit der zweite
  // Durchlauf nicht erneut fragt).
  document.querySelectorAll('.account-address-delete').forEach(function (knopf) {
    knopf.addEventListener('click', function (e) {
      if (knopf.getAttribute('data-nexus-bestaetigt') === 'ja') {
        knopf.removeAttribute('data-nexus-bestaetigt');
        return;
      }
      e.preventDefault();
      var frage = window.nexusBestaetigen || function (optionen) {
        return Promise.resolve(window.confirm(optionen.titel));
      };
      frage({
        titel: 'Adresse löschen?',
        text: 'Diese Adresse wird dauerhaft aus deinem Konto entfernt.',
        okText: 'Löschen',
        abbrechenText: 'Behalten'
      }).then(function (bestaetigt) {
        if (bestaetigt) {
          knopf.setAttribute('data-nexus-bestaetigt', 'ja');
          knopf.click();
        }
      });
    });
  });
})();

// ---- Wunschliste: im Browser gespeichert, weil Shopify von Haus aus
// keine hat. Ein Klick auf das Herz sichert Handle, Titel, Bild und Preis
// lokal — dieselbe Technik wie beim Produktvergleich im Shop. Ohne Konto
// bleibt sie auf das Gerät begrenzt, das ist Kunden von anderen Shops so
// bekannt und braucht keine Erklärung. ----
(function initWunschliste() {
  var SPEICHER_SCHLUESSEL = 'nexus-wunschliste';
  var badge = document.getElementById('wishlistCountBadge');

  function laden() {
    try {
      var roh = localStorage.getItem(SPEICHER_SCHLUESSEL);
      return roh ? JSON.parse(roh) : [];
    } catch (e) { return []; }
  }

  function speichern(liste) {
    try { localStorage.setItem(SPEICHER_SCHLUESSEL, JSON.stringify(liste)); }
    catch (e) { /* Speicher nicht verfügbar — Liste bleibt nur für diese Seite gültig */ }
  }

  function zaehlerAktualisieren() {
    var liste = laden();
    if (!badge) return;
    badge.textContent = liste.length;
    badge.style.display = liste.length ? '' : 'none';
  }

  function istGemerkt(handle) {
    return laden().some(function (p) { return p.handle === handle; });
  }

  function umschalten(eintrag) {
    var liste = laden();
    var index = liste.findIndex(function (p) { return p.handle === eintrag.handle; });
    if (index === -1) {
      liste.push(eintrag);
    } else {
      liste.splice(index, 1);
    }
    speichern(liste);
    zaehlerAktualisieren();
    return index === -1; // true = wurde neu hinzugefügt
  }

  // Für die Wunschlisten-Seite und die Herz-Knöpfe auf Produktkacheln
  window.NexusWunschliste = {
    laden: laden,
    istGemerkt: istGemerkt,
    umschalten: umschalten
  };

  zaehlerAktualisieren();

  // Herz-Knöpfe auf Produktkacheln: delegiert, weil die Kacheln teils
  // dynamisch entstehen (Shop, Startseite, Suche).
  document.addEventListener('click', function (e) {
    var knopf = e.target.closest('[data-wishlist-toggle]');
    if (!knopf) return;
    e.preventDefault();
    e.stopPropagation();
    var eintrag = {
      handle: knopf.getAttribute('data-handle'),
      titel: knopf.getAttribute('data-title'),
      bild: knopf.getAttribute('data-image') || '',
      preis: knopf.getAttribute('data-price') || '',
      url: knopf.getAttribute('data-url') || '#'
    };
    if (!eintrag.handle) return;
    var hinzugefuegt = umschalten(eintrag);
    knopf.classList.toggle('is-active', hinzugefuegt);
  });

  // Beim Laden jeder Seite: Herzen markieren, die schon gemerkt sind.
  document.querySelectorAll('[data-wishlist-toggle]').forEach(function (knopf) {
    if (istGemerkt(knopf.getAttribute('data-handle'))) knopf.classList.add('is-active');
  });
})();

// ---- Nexus-Auswahlfeld ----
// Das aufgeklappte Menü eines <select> wird vom Betriebssystem gezeichnet
// und lässt sich mit CSS nicht gestalten — im Shop erschien deshalb ein
// schwarzes Systemfenster, das nicht zum übrigen Design passte. Diese
// Funktion legt eine eigene, gestaltbare Darstellung darüber.
//
// Wichtig: das echte <select> bleibt erhalten und behält seinen Wert. Es
// wird nur unsichtbar gemacht (siehe .nx-select select im CSS). Dadurch
// funktioniert das Absenden an Shopify unverändert, die Pflichtfeld-
// Prüfung des Browsers greift weiterhin, und falls dieses Skript nicht
// lädt, sieht der Kunde das ganz normale Auswahlfeld statt gar nichts.
  (function nxSelectInit() {
    var alleFelder = document.querySelectorAll('select[data-nx-select]');
    if (!alleFelder.length) return;

    function pfeilSvg() {
      return '<svg class="nx-select-pfeil" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>';
    }
    function hakenSvg() {
      return '<svg class="nx-select-check" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';
    }

    function alleSchliessen(ausser) {
      document.querySelectorAll('.nx-select-panel.is-open').forEach(function (p) {
        if (p === ausser) return;
        p.classList.remove('is-open');
        var k = p.parentElement && p.parentElement.querySelector('.nx-select-knopf');
        if (k) {
          k.classList.remove('is-open');
          k.setAttribute('aria-expanded', 'false');
        }
      });
    }

    alleFelder.forEach(function (feld) {
      // Doppelten Aufbau vermeiden, falls die Funktion mehrfach läuft.
      if (feld.parentElement && feld.parentElement.classList.contains('nx-select')) return;

      var huelle = document.createElement('div');
      huelle.className = 'nx-select';
      feld.parentElement.insertBefore(huelle, feld);
      huelle.appendChild(feld);

      var knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'nx-select-knopf';
      knopf.setAttribute('aria-haspopup', 'listbox');
      knopf.setAttribute('aria-expanded', 'false');
      var beschriftung = document.createElement('span');
      knopf.appendChild(beschriftung);
      knopf.insertAdjacentHTML('beforeend', pfeilSvg());

      var panel = document.createElement('div');
      panel.className = 'nx-select-panel';
      panel.setAttribute('role', 'listbox');

      function beschriftungSetzen() {
        var gewaehlt = feld.options[feld.selectedIndex];
        beschriftung.textContent = gewaehlt ? gewaehlt.textContent : '';
        // Platzhalter (leerer Wert) gedämpft darstellen, wie bei einem
        // nicht ausgefüllten Textfeld.
        knopf.classList.toggle('ist-platzhalter', !gewaehlt || gewaehlt.value === '');
      }

      Array.prototype.forEach.call(feld.options, function (option, index) {
        var eintrag = document.createElement('button');
        eintrag.type = 'button';
        eintrag.className = 'nx-select-option';
        eintrag.setAttribute('role', 'option');
        eintrag.textContent = option.textContent;
        eintrag.insertAdjacentHTML('beforeend', hakenSvg());
        if (index === feld.selectedIndex) eintrag.classList.add('is-active');

        eintrag.addEventListener('click', function () {
          feld.selectedIndex = index;
          // change auslösen, damit alles reagiert, was am echten Feld hängt.
          feld.dispatchEvent(new Event('change', { bubbles: true }));
          panel.querySelectorAll('.nx-select-option').forEach(function (o) {
            o.classList.remove('is-active');
          });
          eintrag.classList.add('is-active');
          beschriftungSetzen();
          panel.classList.remove('is-open');
          knopf.classList.remove('is-open');
          knopf.setAttribute('aria-expanded', 'false');
        });
        panel.appendChild(eintrag);
      });

      knopf.addEventListener('click', function (e) {
        e.stopPropagation();
        var warOffen = panel.classList.contains('is-open');
        alleSchliessen(panel);
        panel.classList.toggle('is-open', !warOffen);
        knopf.classList.toggle('is-open', !warOffen);
        knopf.setAttribute('aria-expanded', warOffen ? 'false' : 'true');
      });

      huelle.appendChild(knopf);
      huelle.appendChild(panel);
      beschriftungSetzen();

      // Falls der Wert von außen geändert wird (z.B. Formular-Reset).
      feld.addEventListener('change', beschriftungSetzen);
    });

    document.addEventListener('click', function () { alleSchliessen(null); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') alleSchliessen(null);
    });
  })();

// ---- FAQ-Sammelseite: Suche und Themenleiste ----
// Läuft nur auf /pages/faq (dort gibt es #faqSuche), auf allen anderen
// Seiten mit FAQ-Bereichen passiert nichts.
//
// Die Suche zerlegt die Eingabe in einzelne Wörter, die ALLE irgendwo
// vorkommen müssen — "PC Konfig" findet damit den Konfigurator-Block,
// obwohl diese zwei Wörter so nirgends zusammenhängend stehen.
// Teiltreffer sind gewollt: "konfig" findet "Konfigurator" und
// "Konfiguration". Umlaute und Groß-/Kleinschreibung werden vereinheitlicht,
// damit "ruckgabe" auch "Rückgabe" findet.
  (function faqSucheInit() {
    var suchfeld = document.getElementById('faqSuche');
    var bloecke = document.getElementById('faqBloecke');
    if (!suchfeld || !bloecke) return;

    var leerenKnopf = document.getElementById('faqSucheLeeren');
    var keineTreffer = document.getElementById('faqKeineTreffer');
    var themenLeiste = document.getElementById('faqThemen');
    var alleBloecke = Array.prototype.slice.call(bloecke.querySelectorAll('.faq-block'));
    var aktivesThema = 'alle';

    function vereinheitlichen(text) {
      return String(text)
        .toLowerCase()
        .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    // Durchsuchbaren Text je Frage einmal vorbereiten: Frage, Antwort und
    // die zusätzlichen Stichwörter aus data-suchbegriffe.
    var eintraege = [];
    alleBloecke.forEach(function (block) {
      block.querySelectorAll('.faq-item').forEach(function (item) {
        var frage = item.querySelector('.faq-question');
        var antwort = item.querySelector('.faq-answer');
        eintraege.push({
          element: item,
          block: block,
          text: vereinheitlichen(
            (frage ? frage.textContent : '') + ' ' +
            (antwort ? antwort.textContent : '') + ' ' +
            (item.getAttribute('data-suchbegriffe') || '')
          )
        });
      });
    });

    function filtern() {
      var suchbegriff = vereinheitlichen(suchfeld.value);
      var woerter = suchbegriff ? suchbegriff.split(' ').filter(Boolean) : [];
      if (leerenKnopf) leerenKnopf.hidden = !suchfeld.value;

      var gesamtTreffer = 0;

      eintraege.forEach(function (e) {
        var passtZumThema = aktivesThema === 'alle' || e.block.getAttribute('data-thema') === aktivesThema;
        // Alle Suchwörter müssen vorkommen, jedes als Teiltreffer.
        var passtZurSuche = woerter.every(function (w) {
          // Bei kurzen Wörtern (bis 5 Zeichen) nur am WORTANFANG suchen —
          // sonst fand "raten" auch "beraten" und "gerne" und lieferte
          // Treffer aus völlig anderen Themenblöcken. Längere Wörter dürfen
          // weiterhin überall greifen, damit "konfig" auch "Konfigurator"
          // und "Konfiguration" findet.
          if (w.length <= 5) {
            return (' ' + e.text).indexOf(' ' + w) !== -1;
          }
          return e.text.indexOf(w) !== -1;
        });
        var sichtbar = passtZumThema && passtZurSuche;
        e.element.hidden = !sichtbar;
        if (sichtbar) gesamtTreffer++;
      });

      // Blöcke ohne sichtbare Frage ganz ausblenden.
      alleBloecke.forEach(function (block) {
        var hatSichtbare = !!block.querySelector('.faq-item:not([hidden])');
        block.hidden = !hatSichtbare;
      });

      if (keineTreffer) keineTreffer.hidden = gesamtTreffer > 0;
    }

    suchfeld.addEventListener('input', filtern);

    if (leerenKnopf) {
      leerenKnopf.addEventListener('click', function () {
        suchfeld.value = '';
        filtern();
        suchfeld.focus();
      });
    }

    if (themenLeiste) {
      themenLeiste.addEventListener('click', function (e) {
        var chip = e.target.closest('.faq-thema-chip');
        if (!chip) return;
        e.preventDefault();
        aktivesThema = chip.getAttribute('data-thema') || 'alle';
        themenLeiste.querySelectorAll('.faq-thema-chip').forEach(function (c) {
          c.classList.remove('is-active');
        });
        chip.classList.add('is-active');
        filtern();
        // Bei einem konkreten Thema dorthin scrollen; bei "Alle" nach oben.
        if (aktivesThema !== 'alle') {
          var ziel = document.getElementById(aktivesThema);
          if (ziel) ziel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          bloecke.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    // Direktverlinkung von außen: /pages/faq#zahlung öffnet gleich das
    // passende Thema (z.B. aus einer Support-Mail heraus).
    if (window.location.hash) {
      var gewuenscht = window.location.hash.slice(1);
      var passenderChip = themenLeiste
        ? themenLeiste.querySelector('[data-thema="' + gewuenscht + '"]')
        : null;
      if (passenderChip) passenderChip.click();
    }
  })();

// ---- Newsletter-Bestätigungsseite verschönern (Freigabe Halil 02.09.2026) ----
// Shopify leitet den Kunden nach dem Double-Opt-in auf eine Seite ohne
// Theme-Template und kippt dort nur nackten Text ins Layout (h1 mit
// Shopnamen + "Vielen Dank, dass du dich für unsere Mailingliste
// angemeldet hast." + Abmelden-Link). An der Weiterleitung selbst ändern
// wir NICHTS — diese Schicht erkennt genau diese Seite und tauscht den
// kargen Block gegen die NEXUS-Bühne aus. Erkennung bewusst doppelt
// abgesichert (Abmelde-Link UND Mailinglisten-Text im selben kleinen
// Block) — auf jeder anderen Seite passiert exakt nichts, und wenn
// Shopify die Struktur mal ändert, bleibt einfach die Standardseite
// stehen. Der Original-Abmeldelink wird 1:1 übernommen.
(function () {
  // Zwei Einstiege (Halils Live-Test, 02.09.2026): Die BESTÄTIGUNGS-Seite
  // trägt einen Abmelde-Link — die ABMELDE-Seite aber nicht (man ist ja
  // schon abgemeldet, dort steht nur noch Text). Deshalb zusätzlich der
  // Einstieg über die Überschrift + Mailinglisten-Text.
  function blockAb(start) {
    var knoten = start;
    for (var i = 0; i < 8 && knoten; i++) {
      knoten = knoten.parentElement;
      if (!knoten || knoten === document.body) return null;
      if (/mailingliste/i.test(knoten.textContent || '')) return knoten;
    }
    return null;
  }

  var container = null;
  var abmeldeLink = document.querySelector('a[href*="unsubscribe"]');
  if (abmeldeLink) container = blockAb(abmeldeLink);
  if (!container) {
    var ueberschriften = document.querySelectorAll('h1');
    for (var u = 0; u < ueberschriften.length && !container; u++) {
      if (/mailingliste/i.test((ueberschriften[u].parentElement || {}).textContent || '')) {
        container = blockAb(ueberschriften[u]);
      }
    }
  }
  if (!container) return;

  // Sicherheitsnetz: Der Shopify-Block ist winzig. Enthält der gefundene
  // Container Theme-Bausteine oder viel Text, sind wir auf einer normalen
  // Seite gelandet — dann nichts anfassen.
  if ((container.textContent || '').length > 600) return;
  if (container.querySelector('.footer-col, nav, form, .nl2-pille, .fnl2-pille')) return;

  var abgemeldet = /abgemeldet/i.test(container.textContent || '');
  // Auf der Abmelde-Seite gibt es keinen Abmelde-Link (Einstieg 2) —
  // der href wird nur im Bestätigungs-Zweig gebraucht.
  var abmeldeHref = abmeldeLink ? abmeldeLink.getAttribute('href') : '';
  var HAKEN_SVG = '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';
  var FUNKEL_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8z"/></svg>';
  var MINI_FUNKEL_SVG = '<svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8z"/></svg>';
  var HAKEN_KLEIN = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5"><polyline points="20 6 9 17 4 12"/></svg>';

  var inhalt;
  if (!abgemeldet) {
    inhalt =
      '<div class="nlb-buehne">' +
        '<svg class="nlb-deko" style="top:30px;left:6%" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>' +
        '<svg class="nlb-deko" style="bottom:24px;right:8%;transform:rotate(10deg)" width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>' +
        '<div class="nlb-hakenwrap">' +
          '<span class="nlb-ring"></span><span class="nlb-ring nlb-r2"></span><span class="nlb-ring nlb-r3"></span>' +
          '<span class="nlb-funkel" style="top:-6px;right:-12px">' + FUNKEL_SVG + '</span>' +
          '<span class="nlb-funkel nlb-funkel2" style="bottom:-4px;left:-16px">' + MINI_FUNKEL_SVG + '</span>' +
          '<span class="nlb-haken">' + HAKEN_SVG + '</span>' +
        '</div>' +
        '<div class="nlb-eyebrow">NEXUS NEWSLETTER</div>' +
        '<h1 class="nlb-titel">Anmeldung <em>bestätigt!</em></h1>' +
        '<p class="nlb-text">Schön, dass du dabei bist! Ab jetzt landen exklusive Angebote, Neuheiten und Technik-Tipps direkt in deinem Postfach — immer zuerst bei dir.</p>' +
        '<div class="nlb-vorteile">' +
          '<span class="nlb-vorteil"><i>' + HAKEN_KLEIN + '</i>Exklusive Angebote</span>' +
          '<span class="nlb-vorteil"><i>' + HAKEN_KLEIN + '</i>Neuheiten zuerst</span>' +
          '<span class="nlb-vorteil"><i>' + HAKEN_KLEIN + '</i>Tipps &amp; Tricks</span>' +
        '</div>' +
        '<div class="nlb-knoepfe">' +
          '<a class="nlb-btn-voll" href="/">Jetzt stöbern <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></a>' +
          '<a class="nlb-btn-rand" href="/pages/pc-konfigurator">Zum PC Konfigurator</a>' +
        '</div>' +
        '<p class="nlb-abmelden">Du kannst dich jederzeit wieder <a href="' + abmeldeHref + '">abmelden</a>.</p>' +
      '</div>';
  } else {
    // Abmelde-Seite: ruhig und neutral, mit offener Tür zurück. Liefert
    // Shopify im Block einen Link mit (z. B. "wieder anmelden"), wird er
    // als zweiter Knopf übernommen — sonst führt nur die Startseite zurück.
    var wiederLink = container.querySelector('a[href]');
    var wiederKnopf = wiederLink
      ? '<a class="nlb-btn-rand" href="' + wiederLink.getAttribute('href') + '">Wieder anmelden</a>'
      : '';
    inhalt =
      '<div class="nlb-buehne nlb-neutral">' +
        '<div class="nlb-hakenwrap"><span class="nlb-haken nlb-haken-grau"><svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg></span></div>' +
        '<div class="nlb-eyebrow">NEXUS NEWSLETTER</div>' +
        '<h1 class="nlb-titel">Du bist abgemeldet</h1>' +
        '<p class="nlb-text">Alles erledigt — du bekommst ab sofort keine Marketing-Mails mehr von uns. Falls du es dir anders überlegst, bist du jederzeit wieder willkommen.</p>' +
        '<div class="nlb-knoepfe"><a class="nlb-btn-voll" href="/">Zur Startseite <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></a>' + wiederKnopf + '</div>' +
      '</div>';
  }

  container.innerHTML = inhalt;
  container.classList.add('nlb-seite');
})();


// ---- Shopify-Challenge-Seite veredeln (Freigabe Halil 02.09.2026) ----
// Die Grundgestaltung macht nexus-base.css über Shopifys offizielle
// Klassen; hier kommt der NEXUS-Kopf (Schild + freundliche Ansprache)
// und die beruhigende Fußzeile dazu. Existiert der Container nicht,
// passiert nichts; schlägt dieses Skript fehl, bleibt die CSS-gestaltete
// Karte mit Shopifys Standardtext stehen — nie eine kaputte Seite.
(function () {
  var container = document.querySelector('.shopify-challenge__container');
  if (!container) return;

  var kopf = document.createElement('div');
  kopf.className = 'nx-challenge-kopf';
  kopf.innerHTML =
    '<span class="nx-challenge-schild"><svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg></span>' +
    '<h2>Kurze Sicherheitsprüfung</h2>' +
    '<p>Wir schützen unsere Formulare vor automatisierten Anfragen.<br>Einmal bestätigen — dann geht es sofort weiter.</p>';
  container.insertBefore(kopf, container.firstChild);

  var hinweis = document.createElement('p');
  hinweis.className = 'nx-challenge-hinweis';
  hinweis.textContent = 'Deine Eingaben bleiben erhalten — nach der Bestätigung wird alles übermittelt.';
  container.appendChild(hinweis);

  container.classList.add('nx-challenge-bereit');
})();

// ---- Mega menu "IT & Business" (TD-Import 10/2026) ----
// Eigenstaendiger Klon von initMegaMenu: zweites Dropdown mit eigenen
// IDs. Klick auf den jeweils anderen Trigger zaehlt als "ausserhalb"
// und schliesst dieses Menue automatisch mit.
(function initItMenu() {
  var trigger = document.getElementById('itMenuTrigger');
  var menu = document.getElementById('itMenu');
  if (!trigger || !menu) return;

  function openMenu() {
    menu.classList.add('is-open');
    trigger.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    menu.classList.remove('is-open');
    trigger.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
  }

  function toggleMenu() {
    if (menu.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  trigger.addEventListener('click', function (e) {
    e.stopPropagation();
    toggleMenu();
  });

  // Capture-Phase — siehe Kommentar bei initMegaMenu: schliesst auch
  // bei Klicks, deren Handler die Ereignis-Weitergabe stoppen.
  document.addEventListener('click', function (e) {
    if (!menu.contains(e.target) && !trigger.contains(e.target)) {
      closeMenu();
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });
})();

// ---- Mobiles Menue "Lade" (Variante A, 03.10.2026) ----
// Burger oeffnet die Lade von links, Schatten/X/Escape schliessen,
// Akkordeons klappen Kategorien und IT & Business auf. Existiert nur
// unter 900px (CSS) — am Desktop ist alles display:none, die Handler
// hier laufen dann schlicht ins Leere.
(function initMobilMenue() {
  var knopf = document.getElementById('mobilMenueKnopf');
  var menue = document.getElementById('mobilMenue');
  if (!knopf || !menue) return;
  var schatten = document.getElementById('mobilMenueSchatten');
  var schliessen = document.getElementById('mobilMenueSchliessen');

  function oeffnen() {
    menue.classList.add('ist-offen');
    menue.setAttribute('aria-hidden', 'false');
    knopf.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('mm-sperre');
  }

  function zu() {
    menue.classList.remove('ist-offen');
    menue.setAttribute('aria-hidden', 'true');
    knopf.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('mm-sperre');
  }

  knopf.addEventListener('click', function (e) {
    e.stopPropagation();
    oeffnen();
  });
  if (schliessen) schliessen.addEventListener('click', zu);
  if (schatten) schatten.addEventListener('click', zu);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') zu();
  });

  // Akkordeons: max-height auf die echte Inhaltshoehe setzen, damit die
  // CSS-Transition weich laeuft; beim Zuklappen zurueck auf 0.
  menue.querySelectorAll('.mm-klapp').forEach(function (kopf) {
    kopf.addEventListener('click', function () {
      var offen = kopf.getAttribute('aria-expanded') === 'true';
      var panel = kopf.nextElementSibling;
      if (!panel || !panel.classList.contains('mm-unter')) return;
      kopf.setAttribute('aria-expanded', offen ? 'false' : 'true');
      panel.style.maxHeight = offen ? '0px' : panel.scrollHeight + 'px';
    });
  });

  // Hell/Dunkel im Lade-Fuss loest den bestehenden Header-Schalter aus —
  // eine Logik, ein Speicherort (nexus-theme in localStorage).
  var thema = document.getElementById('mobilMenueThema');
  var themaSchalter = document.getElementById('themeToggle');
  if (thema && themaSchalter) {
    thema.addEventListener('click', function () {
      themaSchalter.click();
    });
  }
})();


/* ===== EU-Energielabel in Produktkacheln (10/2026): Mini-Pfeil liegt in
   einer <a>-Kachel — Klick wird in der CAPTURE-Phase abgefangen, damit die
   Kachel-Navigation nicht ausloest, und oeffnet das Label im neuen Tab. ===== */
(function initEnergieLabelKacheln() {
  document.addEventListener('click', function (e) {
    var knopf = e.target && e.target.closest ? e.target.closest('.el-pfeil-mini') : null;
    if (!knopf) return;
    e.preventDefault();
    e.stopPropagation();
    var url = knopf.getAttribute('data-el-label');
    if (url) window.open(url, '_blank', 'noopener');
  }, true);
})();
